import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { FDStack } from '@facet-wealth/design';
import MessageSkeleton from 'Components/ComponentLibrary/Atoms/Skeletons/MessageSkeleton';
import InvitationLinkButtonPicker
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/EstatePlanMessageContent/InvitationLinkButtonPicker';
import DataContainer from 'Components/UI/DataContainer';
import fr from 'facet-rest';
import Sentry from 'Integrations/Sentry';
import RichTextDisplayPicker
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/RichTextDisplayPicker';

const EstatePlanMessageContent = ({
  messageResource,
  onLoadComplete,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [estatePlanMessageResource, setEstatePlanMessageResource] = useState(null);

  const fetchEstatePlanMessageResource = async () => {
    try {
      const estatePlanMessageResourceFromRelationship = await messageResource.withRelationship(fr.relationships.estatePlanMessage.name,
        async () => {
          const [withRelationshipEstatePlanMessageResource] = await messageResource.relationship(fr.relationships.estatePlanMessage.name).link('related').get();
          return withRelationshipEstatePlanMessageResource;
        },
        () => null);
      setEstatePlanMessageResource(estatePlanMessageResourceFromRelationship);
    } catch (err) {
      Sentry.createSentryErrorLog(err);
    }
  };

  useComponentDidMount(async () => {
    setIsLoading(true);
    await fetchEstatePlanMessageResource();
    setIsLoading(false);
    onLoadComplete();
  });

  return (
    <DataContainer
      loading={isLoading}
      skeleton={MessageSkeleton}
      component={() => (
        <FDStack spacing={2} direction={'column'}>
          <RichTextDisplayPicker content={messageResource.attr('content')} resource={messageResource} />
          {estatePlanMessageResource ? <InvitationLinkButtonPicker estatePlanMessageResource={estatePlanMessageResource} /> : null}
        </FDStack>
      )}
    />
  );
};

EstatePlanMessageContent.defaultProps = {
  onLoadComplete: noop,
};

EstatePlanMessageContent.propTypes = {
  messageResource: PropTypes.object.isRequired,
  onLoadComplete: PropTypes.func,
};


export default EstatePlanMessageContent;
